import { render } from "./MessageTemplateList.vue?vue&type=template&id=068c68eb"
import script from "./MessageTemplateList.vue?vue&type=script&lang=js"
export * from "./MessageTemplateList.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__